module.exports = __webpack_public_path__ + "static/media/6_22.83d6027d.JPG";